/**
 * Work-form panel service defaults — resolves which installation service a
 * freshly created panel row starts on. Every panel on a work form is billed
 * against one panel-type service, and the form refuses to submit a panel with
 * none chosen, so a new row opens on the first service the crew has available
 * rather than an empty picker they must clear by hand.
 *
 * Service options reach the form already narrowed to panel-type services and
 * already flattened to the `{ id, label }` picker shape by WorkFormView; the
 * same shape backs the PanelSubForm menu items, so this module reads `id` and
 * never re-narrows by service type.
 *
 * Contains:
 * - defaultPanelInstallationService — first available panel service id, or ''
 *
 * Returns plain JS — no JSX, no redux.
 */

/**
 * @param {{ id: number, label: string }[]} serviceOptions - Panel-type service
 *   picker options as supplied to WorkForm, in menu order.
 * @returns {number|string} The first option's id, or `''` when the crew has no
 *   panel service to pick — the empty value PanelSubForm's Select renders and
 *   the panel schema rejects, which keeps an unservable panel from submitting.
 */
export function defaultPanelInstallationService(serviceOptions) {
  return serviceOptions?.[0]?.id ?? '';
}
